import { ReactNode } from 'react';
import ClerkAuthProvider from './ClerkAuthProvider';
import {
  useAuthContext,
  type AuthContextType,
} from './auth-context';

// Shared contract lives in ./auth-context (REK-1985 / SSO.4); re-exported
// here so existing importers keep working unchanged.
export { useAuthContext };
export type { AuthContextType };

/**
 * Auth provider — Clerk is the sole engine (SSO Wave 3, REK-2166).
 *
 * Previously dispatched between SupabaseAuthProvider and ClerkAuthProvider
 * based on VITE_AUTH_PROVIDER. The flag and Supabase engine have been removed;
 * this is now a thin wrapper around ClerkAuthProvider.
 */
export function AuthProvider({ children }: { children: ReactNode }) {
  return <ClerkAuthProvider>{children}</ClerkAuthProvider>;
}
